import type {StockAdjustmentBlockedReason, StockLevelAdjustmentResponse} from './schemas'

function formatUnitCount(count: number): string {
    return `${count} ${count === 1 ? 'unit' : 'units'}`
}

function formatBlockedReason(reason: StockAdjustmentBlockedReason): string {
    if (reason.reason === 'deployed_or_in_transit') {
        return `${reason.count} deployed or in transit`
    }
    return `${reason.count} assigned to a job`
}

export function formatStockAdjustmentSuccessMessage(result: StockLevelAdjustmentResponse): string {
    if (result.appliedDelta > 0) {
        return `Added ${formatUnitCount(result.added)}. Stock level is now ${result.newCount}.`
    }
    if (result.appliedDelta < 0) {
        return `Removed ${formatUnitCount(result.removed)}. Stock level is now ${result.newCount}.`
    }
    return `Stock level is ${result.newCount}.`
}

export function formatStockAdjustmentWarningMessage(
    result: StockLevelAdjustmentResponse,
): string | null {
    if (result.blockedCount <= 0) {
        return null
    }

    const reasonSummary =
        result.blockedReasons.length > 0
            ? result.blockedReasons.map(formatBlockedReason).join('; ')
            : 'some units could not be removed'

    return `Could not remove ${formatUnitCount(result.blockedCount)} (${reasonSummary}). Check field status before removing more stock.`
}
